//#region src/price-plans/enum/subscription-interval-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.day = "day", e.week = "week", e.month = "month", e.year = "year", e;
}({});
//#endregion
export { e as SubscriptionIntervalEnum };
